import { useGetSessionId } from "@Data-Protocol/event-tracker"
import { useSetAtom } from "jotai"
import { useEffect } from "react"
import { useAtomValue } from "~/atoms"
import {
  aAnsweredQuestionIndices,
  aSentimentAnswers,
  aSentimentQuestions,
} from "~/atoms/questions"

export function usePrefillSentimentData(videoId: string | undefined) {
  const sessionId = useGetSessionId()
  const sentimentQuestions = useAtomValue(aSentimentQuestions)
  const setSentimentAnswers = useSetAtom(aSentimentAnswers)
  const setAnsweredIndices = useSetAtom(aAnsweredQuestionIndices)
  useEffect(() => {
    if (sentimentQuestions.length === 0) return
    setSentimentAnswers((prev) => {
      const next = { ...prev }
      sentimentQuestions.forEach((q) => {
        if (!next[q.id]) {
          next[q.id] = { answer: null, question: q.question, status: null }
        }
      })
      return next
    })
  }, [sentimentQuestions])

  useEffect(() => {
    if (!sessionId || !videoId || sentimentQuestions.length === 0) return
    sentimentQuestions.forEach((q, index) => {
      const questionKey = `sentiment-question-${q.id}`
      fetch(
        `/api/feedback?sessionId=${sessionId}&videoId=${videoId}&questionKey=${questionKey}`
      )
        .then((res) => res.json())
        .then((data: { feedback_gave: string } | null) => {
          if (data?.feedback_gave) {
            setSentimentAnswers((prev) => ({
              ...prev,
              [q.id]: {
                answer: data.feedback_gave,
                question: q.question,
                status: "answered",
              },
            }))
            setAnsweredIndices((prev) => {
              const next = new Set(prev)
              next.add(index)
              return next
            })
          }
        })
        .catch(() => {})
    })
  }, [sessionId, videoId, sentimentQuestions])
}
